import { render, staticRenderFns } from "./CommunitySideNav.vue?vue&type=template&id=1b2f20b0&scoped=true&"
import script from "./CommunitySideNav.vue?vue&type=script&lang=js&"
export * from "./CommunitySideNav.vue?vue&type=script&lang=js&"
import style0 from "./CommunitySideNav.vue?vue&type=style&index=0&id=1b2f20b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f20b0",
  null
  
)

export default component.exports